<ion-tabs
	id="main-content"
	[class]="isDesktop() ? 'side' : ''"
	class="bg-[#f8f8f8] dark:bg-[#0f0f0f]">
	<ion-tab-bar
		[class]="
			isDesktop()
				? 'side justify-start overflow-y-auto'
				: 'justify-around m-4 rounded-full translucency shorten h-18'
		"
		mode="md"
		slot="bottom">
		@if (isDesktop()) {
			<img
				class="w-11 flex-shrink-0 my-6 dark:block hidden"
				src="assets/images/logo/racapp-monogram-white.png"
				alt="Logo image" />
			<img
				class="w-11 flex-shrink-0 my-6 dark:hidden block"
				src="assets/images/logo/racapp-monogram-black.png"
				alt="Logo image" />
		}
		<div [class]="isDesktop() ? 'flex flex-col h-80 w-full px-2' : 'contents'">
			<ion-tab-button
				[position]="'right'"
				[ultraToolTip]="'tabs|home' | transloco"
				[tab]="'home'"
				class="bg-transparent hover-layer rounded-full">
				<ion-icon
					class="increase-font"
					name="home-outline"
					aria-hidden="true"></ion-icon>
			</ion-tab-button>

			<ion-tab-button
				[ultraToolTip]="'tabs|tracking' | transloco"
				[position]="'right'"
				[tab]="'tracking'"
				class="bg-transparent w-full hover-layer rounded-full">
				<ion-icon
					class="increase-font"
					name="compass-outline"
					aria-hidden="true"></ion-icon>
			</ion-tab-button>

			<ion-tab-button
				[ultraToolTip]="'tabs|modules' | transloco"
				[position]="'right'"
				(click)="toggleIonMenu()"
				class="bg-transparent w-full hover-layer rounded-full">
				<ion-icon
					class="increase-font"
					name="apps-outline"
					aria-hidden="true"></ion-icon>
			</ion-tab-button>
			<ion-tab-button
				[ultraToolTip]="'tabs|my-account' | transloco"
				[position]="'right'"
				(click)="openUserMenu()"
				class="bg-transparent w-full hover-layer rounded-full"
				[class]="isDesktop() ? 'mt-auto mb-6' : ''">
				<ion-icon
					class="increase-font"
					name="person-outline"
					aria-hidden="true"></ion-icon>
			</ion-tab-button>
		</div>
	</ion-tab-bar>
</ion-tabs>
@if (currentModule() && navigedToModule()) {
	@if (currentModule() !== moduleEnum.RENTAL_RESERVATIONS) {
		<ion-fab slot="fixed" vertical="bottom" horizontal="end" class="pb-[2px]">
			<a [routerLink]="link()">
				<ion-fab-button
					[position]="isDesktop() ? 'left' : 'top'"
					[ultraToolTip]="'shared|add-new' | transloco"
					class="h-16 w-16">
					<ion-icon name="add" class="text-white"></ion-icon>
				</ion-fab-button>
			</a>
		</ion-fab>
	}
} @else {
	<ion-fab slot="fixed" vertical="bottom" horizontal="end" class="pb-[2px]">
		<ion-fab-button (click)="openTerminalMenu()" class="h-16 w-16">
			<ion-icon name="sparkles-outline" class="text-white"></ion-icon>
		</ion-fab-button>
	</ion-fab>
}

<ion-menu
	[type]="isDesktop() ? 'overlay' : 'push'"
	[class]="isDesktop() ? 'left-20 terminal-menu' : 'terminal-menu'"
	#terminalMenu
	[swipeGesture]="false"
	menuId="terminalMenu"
	content-id="main-content">
	<ion-content class="ion-padding">
		<app-terminal />
		<ion-fab slot="fixed" vertical="bottom" horizontal="center">
			<button (click)="closeTerminal()" ultra-primary svgIcon="close"></button>
		</ion-fab>
	</ion-content>
</ion-menu>

<ion-menu
	[type]="isDesktop() ? 'overlay' : 'push'"
	[class]="isDesktop() ? 'start-menu-desktop left-20' : 'start-menu-mobile'"
	#userMenu
	[swipeGesture]="false"
	(ionDidClose)="onUserMenuClosed()"
	menuId="userMenu"
	content-id="main-content">
	<ion-content class="ion-padding">
		<ion-nav #userMenuNav></ion-nav>
		<ng-template #userMenuRoot>
			<div>
				@if (!isDesktop()) {
					<div class="flex justify-end p-2 pb-0 sticky top-0 z-10">
						<button
							ultra-primary
							(click)="closeUserMenu()"
							[svgIcon]="'arrow_back'"></button>
					</div>
				}

				<div class="flex flex-col w-full p-2 gap-2">
					<button
						(click)="toPreferences()"
						ultra-menu-card
						[item]="preferences"></button>
					<span ultra-menu-item-wrapper>
						<button
							ultra-menu-item
							(click)="toPortal()"
							[content]="'shared|portal'"
							svgIcon="space_dashboard"></button>
					</span>
					<span ultra-menu-item-wrapper>
						<button
							ultra-menu-item
							(click)="logout()"
							[content]="'shared|logout'"
							svgIcon="logout"></button>
					</span>
				</div>
			</div>
		</ng-template>
	</ion-content>
</ion-menu>

<ion-menu
	[class]="isDesktop() ? 'start-menu-desktop left-20' : 'start-menu-mobile'"
	mode="ios"
	#menu
	[swipeGesture]="false"
	[type]="isDesktop() ? 'overlay' : 'push'"
	content-id="main-content">
	<ion-content class="ion-padding">
		@if (!isDesktop()) {
			<div class="flex justify-end p-2 pb-0 sticky top-0 z-10">
				<button
					ultra-primary
					(click)="closeIonMenu()"
					[svgIcon]="'arrow_back'"></button>
			</div>
		}

		<app-ultra-navigation (menuClose)="closeIonMenu()" />
	</ion-content>
</ion-menu>

@if (navigedToModule()) {
	<ion-menu
		[class]="isDesktop() ? 'end-menu-desktop' : 'end-menu-mobile'"
		side="end"
		mode="ios"
		#moduleMenu
		[type]="'push'"
		[swipeGesture]="false"
		menuId="moduleMenu"
		content-id="main-content">
		<ion-content class="ion-padding">
			<div class="flex justify-start p-2 pb-0 sticky top-0 z-10">
				<button
					ultra-primary
					(click)="closeModuleMenu()"
					[svgIcon]="'arrow_forward'"></button>
			</div>

			<div class="flex flex-col justify-start gap-2 h-full p-2">
				@if (toolbarComponent()) {
					<ng-container
						*ngComponentOutlet="
							toolbarComponent();
							inputs: { stats: stats(), selectItems: selectItems() }
						"></ng-container>
				}
			</div>
		</ion-content>
	</ion-menu>
}
